import React from "react";
import Container from "../common/Container";
import SectionHeader from "../common/SectionHeader";
import { Code2, Smartphone, Palette, Brain, Cloud } from "lucide-react";

const services = [
  {
    title: "Web Application Development",
    description:
      "We build robust, scalable web applications using modern frameworks, clean architecture, and performance-first engineering practices.",
    icon: Code2,
  },
  {
    title: "Mobile App Development",
    description:
      "From idea to app store, we design and develop reliable mobile applications that deliver smooth user experiences across devices.",
    icon: Smartphone,
  },
  {
    title: "UI/UX & Product Design",
    description:
      "We design intuitive interfaces and product experiences that align user needs with clear business objectives.",
    icon: Palette,
  },
  {
    title: "AI & Intelligent Automation",
    description:
      "We integrate AI-driven solutions to automate workflows, enhance decision-making, and unlock actionable insights from data.",
    icon: Brain,
  },
  {
    title: "Cloud Infrastructure & DevOps",
    description:
      "We architect and manage secure cloud environments with automated deployments, monitoring, and scalable infrastructure.",
    icon: Cloud,
  },
  {
    title: "API & Backend Engineering",
    description:
      "We develop secure, well-documented APIs and backend systems that power reliable applications and seamless integrations.",
    icon: Code2,
  },
];


const ServicesPreview = () => {
  return (
    <section className="py-28 bg-white">
      <Container>
        <center>
        <SectionHeader
          eyebrow="Our Services"
          title="End-to-end software development services"
          subtitle="From idea to launch and beyond, we provide everything you need to build and scale your product."
        />
        </center>
        <div className="mt-20 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service) => (
            <div
              key={service.title}
              className="group flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
            >
              {/* Icon */}
              <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-blue-100 text-blue-600 transition-colors group-hover:bg-blue-600 group-hover:text-white">
                <service.icon size={26} />
              </div>

              {/* Content */}
              <div className="mt-6 flex flex-col flex-1">
                <h3 className="text-lg font-semibold text-slate-900">
                  {service.title}
                </h3>

                <p className="mt-3 text-sm leading-relaxed text-slate-600">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default ServicesPreview;
